export default __webpack_public_path__ + "37696240a7272e4244999aa9a4c8ef89.svg";